export default "__VITE_ASSET__BXlixnBn__"